<template>
    <div class="box" @scroll="getLoad">
        <div class="time-line">
            <el-timeline :reverse="false">
                <el-timeline-item v-for="(item, index) in list" :key="index">
                    <div class="time">
                        <div>
                            <span class="year">
                                {{ item?.createTime.substring(5,10)}}
                            </span>
                        </div>
                        <div class="day">{{  item?.createTime.substring(0,4) }}年</div>
                    </div>
                    <div>
                        <div class="list" v-if="recordTab==1">
                            <div>
                                <span>监管状态：</span>
                                <span class="list-status">{{ item.status==0?'正常':'异常' }}</span>
                            </div>
                            <div class="list-worker">
                                <span>创建人：</span>
                                <span>{{ item.createUserName }}</span>
                            </div>
                            <div style="display:flex;flex-wrap:wrap">
                                <div class="list-image" v-for="(itemT,index1) in handelUrl(item?.detailsImages)" :key="index1">
                                    <img :src="(itemT)" class="list-image-card" @click="openDig((itemT),1)" v-if="itemT.indexOf('.mp4')==-1">
                                    <div  v-if="itemT.indexOf('.mp4')!=-1">
                                    <video :src="(itemT)"></video>
                                    <i class="el-icon-video-play list-image-pay" @click="openDig((itemT),2)"></i>
                                </div>
                                </div>
                             
                            </div>
                        </div>
                        <div class="list" v-if="recordTab==2">
                            <div>
                                <span>巡检状态：</span>
                                <span class="list-status">{{ item.inspectStatus ==1?'正常':'异常' }}</span>
                            </div>
                            <div class="list-worker">
                                <span>巡检员：</span>
                                <span>{{ item.inspectByName }}</span>
                            </div>
                            <div style="display:flex;flex-wrap:wrap">
                                <div class="list-image" v-for="(itemT,index2) in handelUrl(item?.inspectImgUrl)" :key="itemT">
                                    <img :src="(itemT)" class="list-image-card" @click="openDig((itemT),1)">
                                </div>
                                <div class="list-image" v-for="(itemT,index3) in handelUrl(item?.inspectVedioUrl)" :key="itemT">
                                    <video :src="(itemT)"></video>
                                    <i class="el-icon-video-play list-image-pay" @click="openDig((itemT),2)"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-timeline-item>
            </el-timeline>
            <div class=loading style='display:block;text-align:center;height:30px;line-height:30px;color: #fff;padding: 10px; z-index:99999'>{{ stopLoding?'已加载全部内容':'加载中...' }}</div>
            <el-dialog :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
                <img :src="urlObj.url" v-show="urlObj.type == 1" width="100%">
                <video :src="urlObj.url" controls width="100%" height="500px" v-show="urlObj.type == 2" id="video" muted autoplay></video>
            </el-dialog>
        </div>
    </div>
</template>
   
<script>
import {getFilePath} from '@/utils/format.js'
export default {
    props:{
        stopLoding:{
            type:Boolean,
            default:true
        },
        list:{
            type:Array,
            default:[]
        },
        recordTab:{
            type:Number,
            default:1
        }
    },
    data() {
        return {
            dialogVisible: false,
            urlObj:{
                url:'',
                type:1
            }
        }
    },
    computed:{
        handelUrl(){
            return (list)=>{
                    return getFilePath(list)
            }
        }

    },
    methods: {
         //实现下拉加载
     getLoad(){
        let boxHeight=document.querySelector('.box').clientHeight
        let scrollHeight =document.querySelector('.box').scrollHeight
        let scrollTop =document.querySelector('.box').scrollTop
		console.log('加载更多00')
       if(scrollHeight<boxHeight+scrollTop+100){
            if(!this.stopLoding){
				console.log('加载更多')
                this.$emit('getLoad')
            }
   
       }
    },
        handleClose() {
            this.dialogVisible = false
        },
        openDig(url,type) {
            this.dialogVisible = true
            this.urlObj.url=url,
            this.urlObj.type=type

        }
    }
}
</script>
<style>
.time-line .el-dialog__body {
    display: flex !important;
    justify-content: center !important;
}
</style>
<style lang="scss" scoped>
.box {
    height: 100%;
    width: 100%;
    overflow-y: auto;
}

::v-deep .el-timeline-item__tail {
    border-left: 2px dashed #E4E7ED
}


.time-line {
    margin-top: .2rem;
    margin-left: 0.75rem;
}

.list {
    font-family: Source Han Sans, Source Han Sans;
    font-weight: 400;
    font-size: 0.15rem;
    color: #FFFFFF;

    &-status {
        color: #85BC3C;
    }

    &-worker {
        margin-top: 0.2rem;

    }

    &-image {
        width: 0.63rem;
        height: 0.63rem;
        border-radius: 0.05rem 0.05rem 0.05rem 0.05rem;
        border: 0.01rem solid #FFFFFF;
        overflow: hidden;
        margin-top: 0.2rem;
        margin-right: 0.1rem;
        position: relative;

        &-pay {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%)
        }

        &-card {
            width: 100%;
            height: 100%;
        }
    }
}

//左侧时间
.time {
    color: #FFFFFF;
    position: absolute;
    left: -0.75rem;
    top: 1px;

    .year {
        font-family: Source Han Sans, Source Han Sans;
        font-weight: 700;
        font-size: 0.18rem;
    }

    .day {
        font-family: Source Han Sans, Source Han Sans;
        font-weight: 350;
        font-size: 0.15rem;
        color: #FFFFFF;
        margin-top: 0.1rem;
    }
}
</style>